import Homebutton from "../Homebutton";

export default function Procedures() {
  return (
    <div>
      <h1>Procedures</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam
        quaerat recusandae exercitationem magnam veniam modi nisi esse at
        aliquid, nihil omnis eligendi, quas, et laborum!
      </p>
      <Homebutton />
    </div>
  );
}
